<header class="main__content__header modal-header">
  <h2 class="modal-title">Selecione o cargo ocupado segundo a resolução do COAF</h2>
  <a class="header__btn__close" (click)="activeModal.dismiss(null)">
    <span aria-hidden="true">X</span>
  </a>
</header>
<main class="main__content__modal modal-body">
  <div class="modal-body px-4">
    <ol type="1" class="pl-0">
      <div class="row" *ngFor="let job of positions; let i=index;">
        <div class="col-1">
          <div class="custom-control custom-radio custom-control-inline float-left">
            <input type="radio" [id]="'customRadioInline_'+ job.key" class="custom-control-input" value="job"
              (click)="selectJob(job)">
            <label class="custom-control-label" [for]="'customRadioInline_'+ job.key"></label>
          </div>
        </div>
        <div class="col-11 p-0">
          <li>
            <span>
              {{job.value}}
            </span>
          </li>
        </div>
      </div>
    </ol>
  </div>
</main>
<!-- <section role="document">
    <div class="modal-header px-4">
      <h3 class="modal-title">Selecione o cargo ocupado segundo a resolução do COAF</h3>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(null)">
          <span aria-hidden="true">X</span>
        </button>
    </div> 
    <div class="modal-body px-4">
      <ol type="1" class="pl-0">
        <div class="row" *ngFor="let job of positions; let i=index;">
          <div class="col-1">
            <div class="custom-control custom-radio custom-control-inline float-left">
              <input type="radio" [id]="'customRadioInline_'+ job.key" class="custom-control-input" value="job"
                (click)="selectJob(job)">
              <label class="custom-control-label" [for]="'customRadioInline_'+ job.key"></label>
            </div>
          </div>
          <div class="col-11">
            <li>
              <span>
                {{job.value}}
              </span>
            </li>
          </div>
        </div>
      </ol>
    </div>
</section> -->